import getConfig from 'next/config';

const {
  publicRuntimeConfig: { BACKEND_URL },
} = getConfig();

const getSrc = (img, styleName = 'original', derivatives = null) => {
  if (typeof img === 'string') {
    let src = img;
    if (styleName !== 'original' && derivatives && derivatives[styleName]) {
      src = derivatives[styleName];
    }
    return src.replace(BACKEND_URL, '');
  }
  // Check SVG and original images.
  if (img.url && img.url.indexOf('.svg') < 0 && styleName !== 'original') {
    return img.meta.derivatives[styleName];
  }
  // TODO check if this needed.
  if (!img.url) {
    return null;
  }

  return img.url.replace(BACKEND_URL, '');
};

export default getSrc;
